import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, LowerCasePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AddressModule } from '@vsolv/core/address/web';
import { PaymentMethodModule, PaymentModule } from '@vsolv/packages/payments/web';
import { PropertiesWebModule } from '@vsolv/packages/properties/web';
import { ContentCardModule } from '@vsolv/ui-kit/card';
import { ModalModule } from '@vsolv/ui-kit/modal';
import { ToastModule } from '@vsolv/ui-kit/toast';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { AppPageModule } from '@vsolv/vectors-ui/app-page';
import { BadgeModule } from '@vsolv/vectors-ui/badge';
import { BreadcrumbsModule } from '@vsolv/vectors-ui/breadcrumbs';
import { ButtonModule } from '@vsolv/vectors-ui/button';
import { CardModule } from '@vsolv/vectors-ui/card';
import { DatePickerModule } from '@vsolv/vectors-ui/date-picker';
import { DialogModule } from '@vsolv/vectors-ui/dialog';
import { DividerModule } from '@vsolv/vectors-ui/divider';
import { FormsModule as VsFormsModule } from '@vsolv/vectors-ui/forms';
import { IconsModule } from '@vsolv/vectors-ui/icons';
import { InfoCardModule } from '@vsolv/vectors-ui/info-card';
import { InputModule } from '@vsolv/vectors-ui/input';
import { LoadingModule } from '@vsolv/vectors-ui/loading';
import { MenuModule } from '@vsolv/vectors-ui/menu';
import { ProgressBarModule } from '@vsolv/vectors-ui/progress-bar';
import { SelectModule } from '@vsolv/vectors-ui/select';
import { SkeletonModule } from '@vsolv/vectors-ui/skeleton';
import { TabsModule } from '@vsolv/vectors-ui/tabs';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { TooltipModule } from '@vsolv/vectors-ui/tooltip';
import { UserAvatarModule } from '@vsolv/vectors-ui/user-avatar';
import { TableModule } from '@vsolv/vectors/table';
import { AssetsWebModule } from '@wsphere/assets/web';
import { CustomerWebModule } from '@wsphere/customers/web';
import { DistributorsWebModule } from '@wsphere/distributors/web';
import { NgPipesModule } from 'ngx-pipes';
import { ClaimModule } from '../claim';
import { WarrantyCoverageModule } from '../coverage';
import { PolicyModule } from '../policy';
import { ContractLedgerWebService, WarrantyWebService } from '../warranty/services';
import {
  PaymentInvoiceComponent,
  PaymentsTableComponent,
  WarrantyPaymentsComponent,
  ContractLedgerCardComponent,
  CoverageCardComponent,
  CoverageCarouselComponent,
  CoverageLiabilityLimitComponent,
  WarrantyAssetCardComponent,
  WarrantyCustomerCardComponent,
  WarrantyCustomFieldsCardComponent,
  WarrantyOverviewCardComponent,
  WarrantyPolicyCardComponent,
  WarrantyRecentClaimsComponent,
  WarrantyStatusPickerComponent,
} from './components';
import { CancelWarrantyDialog, VoidWarrantyDialog } from './dialogs';
import { WarrantyGuard, WarrantyResolver } from './guards';
import { WarrantyAuditPage, WarrantyPageComponent, WarrantyTableComponent } from './pages';

@NgModule({
  exports: [
    PaymentInvoiceComponent,
    PaymentsTableComponent,
    WarrantyTableComponent,
    WarrantyStatusPickerComponent,
    WarrantyPageComponent,
    CoverageCarouselComponent,
    CancelWarrantyDialog,
    VoidWarrantyDialog,
  ],
  providers: [
    WarrantyWebService,
    ContractLedgerWebService,
    WarrantyGuard,
    WarrantyResolver,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    LowerCasePipe,
  ],
  declarations: [
    PaymentInvoiceComponent,
    PaymentsTableComponent,
    WarrantyPaymentsComponent,
    WarrantyTableComponent,
    WarrantyStatusPickerComponent,
    WarrantyPageComponent,
    WarrantyAuditPage,
    WarrantyOverviewCardComponent,
    ContractLedgerCardComponent,

    WarrantyRecentClaimsComponent,
    WarrantyAssetCardComponent,
    CoverageCarouselComponent,
    CoverageCardComponent,
    WarrantyCustomerCardComponent,
    WarrantyPolicyCardComponent,
    WarrantyCustomFieldsCardComponent,
    CoverageLiabilityLimitComponent,

    // Dialogs
    CancelWarrantyDialog,
    VoidWarrantyDialog,
  ],
  imports: [
    PaymentModule,
    PaymentMethodModule,
    DialogModule,
    BreadcrumbsModule,
    UtilsModule,
    BadgeModule,
    IconsModule,
    InputModule,
    TableModule,
    AppPageModule,
    RouterModule,
    CommonModule,
    ContentCardModule,
    CardModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    ToastModule,
    SelectModule,
    CustomerWebModule,
    ButtonModule,
    WarrantyCoverageModule,
    ModalModule,
    AddressModule,
    TooltipModule,
    NgPipesModule,
    TabsModule,
    ClaimModule,
    ThemingModule,
    PropertiesWebModule,
    DividerModule,
    PolicyModule,
    DatePickerModule,
    AssetsWebModule,
    InfoCardModule,
    ProgressBarModule,
    VsFormsModule,
    InputModule,
    MenuModule,
    DistributorsWebModule,
    LoadingModule,
    ClipboardModule,
    UserAvatarModule,
    SkeletonModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WarrantyManagementModule {}
